import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { api } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";

export default function VerifyEmail() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("verified"))
      .catch(() => setStatus("error"));
  }, [params]);

  return (
    <>
      <Navbar />
      <main className="min-h-[calc(100vh-64px)] flex items-center justify-center bg-[#FAFAFA] px-6">
        <div className="w-full max-w-md card-premium p-10 text-center">
          <h1 className="font-display font-bold text-3xl text-slate-900">{t("auth.verifyTitle")}</h1>
          <div className="mt-4 text-slate-600" data-testid="verify-status">
            {status === "pending" && t("common.loading")}
            {status === "verified" && (t("common.success") + " ✓")}
            {status === "error" && t("common.error")}
          </div>
          <Link to="/dashboard" className="btn-primary inline-block mt-6 rounded-full px-6 py-3 font-semibold">
            {t("nav.dashboard")}
          </Link>
        </div>
      </main>
    </>
  );
}
